var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({
      callback: _vm.lazyLoadImage,
      throttle: 250,
      once: true
     }),expression:"{\n      callback: lazyLoadImage,\n      throttle: 250,\n      once: true\n     }"}],staticClass:"app-image",style:(_vm.intristicRatioStyle)},[(_vm.show)?_c('img',{ref:"img",staticClass:"app-image__image",attrs:{"src":_vm.src}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }